import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../compoment/PortraitStage";
import { useEffect, useState } from "react";
import QRCode from "qrcode";
import Expired from "../assets/img/expired.png";
import { useNavigate } from "react-router-dom";

interface ExpiredModalProps extends ModalProps {
  onHide: () => void;
  show: boolean;
  message: string;
  extendTicketUrl: string;
}

const ExpiredModal = ({
  onHide,
  show,
  message,
  extendTicketUrl,
  ...props
}: ExpiredModalProps) => {
  const navigate = useNavigate();
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  useEffect(() => {
    if (!extendTicketUrl) return;

    QRCode.toDataURL(extendTicketUrl, {
      errorCorrectionLevel: "H",
      margin: 1,
      width: 260,
      color: {
        dark: "#000000",
        light: "#FFFFFF",
      },
    })
      .then(setQrCodeUrl)
      .catch((error) => {
        console.error("Unable to generate extend-ticket QR code", error);
      });
  }, [extendTicketUrl]);

  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      show={show}
      onHide={onHide}
      backdrop="static"
      className="expiredModal"
      centered
    >
      <Modal.Body>
        <div className="otpModalBody">
          <img src={Expired} alt="Expired" className="expiredImg" />
          <div className="header">Your ticket is already expired</div>
          <div className="description">
            {message ||
              "Please scan this QR code to extend your ticket and pay."}
          </div>
          <div className="text-center">
            <div className="qrCodeCard">
              {qrCodeUrl && (
                <>
                  <img
                    src={qrCodeUrl}
                    alt="Extend ticket QR Code"
                    className="qrCodeImage"
                  />
                  <div className="qrLogo">MOSIDA</div>
                </>
              )}
            </div>
          </div>
          <div className="mt-4">
            <button
              className="btnPrimary w-100"
              onClick={() => {
                onHide();
                navigate("/");
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ExpiredModal;
